// @flow
import type { ChildrenArray } from 'react';
import React from 'react';
import { productColor } from '../../designSystem.js';
import { HandToolsIcon, GraduateCapIcon } from './icons.js';
import { Language } from '../../languages.js';

// These components provide a template for the various callout boxes
// that contain lists in the investigation.
// Currently there are two types of callout boxes:
// Objectives and Requirements
export function InternalCallOutList(props: {|
  title: string,
  icon:
    | React$Element<typeof HandToolsIcon>
    | React$Element<typeof GraduateCapIcon>,
  children: ChildrenArray<React$Element<any>>,
|}) {
  const { children, title, icon } = props;

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: productColor.aliceBlue,
        padding: '20px 18px',
        border: `2px solid ${productColor.tropicalBlue}`,
        borderRadius: 8,
        display: 'flex',
        gap: 16,
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 16,
          flexShrink: 0,
        }}
      >
        {icon}
        <InternalCallOutHeading>{title}</InternalCallOutHeading>
      </div>
      <div>
        <ul
          style={{
            color: productColor.matisse,
            margin: 0,
            listStyle: 'disc',
          }}
        >
          {React.Children.map(children, (child) => (
            <li>{child}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function InternalCallOutHeading(props: {|
  children: string | React$Element<typeof Language>,
|}) {
  const { children } = props;

  return (
    <div
      style={{
        fontWeight: 600,
        color: productColor.matisse,
        lineHeight: '22px',
      }}
    >
      {children}
    </div>
  );
}
